import React from 'react';
import HomeTemplate from '@templates/Home';

export default function Home() {
  return (
    <HomeTemplate
      title="Tripati Lab"
      description="We are a diverse team of scientists studying the chemistry of natural compounds and models to understand how the Earth works."
    />
  );
}
